import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";

export const FormTextInput = ({ name, control, label, required = false, multiline = false }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error }, formState }) => (
        <TextField
          helperText={error ? error.message : null}
          error={!!error}
          required={required}
          multiline={multiline}
          onChange={onChange}
          value={value}
          fullWidth
          label={label}
          variant="outlined"
        />
      )}
    />
  );
};
